<template>
  <div class="privacy-container">
    <h3 style="text-align:center;">法律声明及隐私权政策</h3>
    <br />
    <p>最近更新日期：2021年3月1日</p>
    <p>生效日期：2021年3月1日</p>
    <br />
    <h5>提示条款</h5>
    <br />
    <p>
      您的信任对我们非常重要，我们深知用户信息安全的重要性，我们将按照法律法规要求，采取安全保护措施，保护您的用户信息安全可控。鉴此，汇才汇能（即www.huicaihuineng.com及相关的应用程序包括但不限于汇才汇能小程序，以下简称“汇才汇能网站”或“本网站”）制定本《法律声明及隐私权政策》（以下或简称“声明和政策”）并提醒您：<b
        >在使用汇才汇能网站的各项服务前，请您务必仔细阅读并透彻理解本《法律声明和隐私权政策》，在确认充分理解并同意后方使用相关产品和服务。一旦您开始使用汇才汇能服务，将被视为对本声明和政策内容的接受和认可。</b
      >
    </p>
    <p>
      如对本声明和政策内容有任何疑问、意见或建议，您可通过电子邮箱hchn_hr@163.com与我们联系。
    </p>
    <br />
    <h5>定义</h5>
    <br />
    <p>
      <b>汇才汇能网站：</b
      >指汇才汇能官网（域名为：www.huicaihuineng.com）以及相关的应用程序包括但不限于汇才汇能小程序。汇才汇能（北京）科技有限公司（以下简称“公司”）是汇才汇能网站的实际经营者。
    </p>
    <p>
      <b>汇才汇能：</b
      >除非另有约定，指汇才汇能（北京）科技有限公司。汇才汇能（北京）科技有限公司是www.huicaihuineng.com网站以及汇才汇能小程序的经营者。
    </p>
    <p>
      <b>用户：</b
      >使用、登陆、浏览汇才汇能网站的相关企业或其他主体（以下简称“服务接受方”）和个人（以下简称“服务提供方”）的合称。
    </p>
    <p>
      <b>用户信息：</b
      >用户信息是指用户注册汇才汇能网站账户，使用汇才汇能网站的服务以及汇才汇能网站为了向用户提供服务，用户提交的或者汇才汇能网站收集的用户会员类信息，如企业名称、姓名、主营业务、行业分类、通讯地址、联系方式等，具体详见隐私权政策第二条所述的信息。
    </p>
    <p>
      <b>管理人（联系人）信息：</b
      >是指用户授权或同意，代表用户注册和使用本平台系统或在本平台进行操作的个人。凡依据本平台流程和要求，用户提供给本平台的指定人士或在本平台上填写其个人信息的人，即是用户的管理人。本平台需要管理人（联系人）提供其个人姓名、身份证件、联系方式及其他必要的信息，如职务或相关执业证照等。
    </p>
    <p>
      <b>业务数据：</b
      >不同于用户信息，是指汇才汇能网站的用户利用汇才汇能的服务上传、下载、分发等通过汇才汇能的技术服务处理的数据。
    </p>
    <br />
    <br />
    <h5>法律声明</h5>
    <br />
    <h6>一、权利归属</h6>
    <p>
      1.1汇才汇能网站的Logo、“汇才汇能”、“huicaihuineng”等文字、图形及其组合，以及汇才汇能网站的其他标识、徽记、汇才汇能服务的名称等未经汇才汇能书面授权，任何人不得以任何方式展示、使用或做其他处理（包括但不限于复制、传播、展示、镜像、上传、下载），也不得向他人表明您有权展示、使用或做其他处理。
    </p>
    <p>
      1.2.汇才汇能网站所有的产品、服务、技术与所有程序（以下或简称“技术服务”）的知识产权均归属于汇才汇能或归其权利人所有。
    </p>
    <p>
      1.3.除非汇才汇能另行声明，汇才汇能拥有汇才汇能在网站内发布文档等信息（包括但不限于文字、图形、图片、照片、音频、视频、图标、色彩、版面设计、电子文档）的所有权利（包括但不限于版权、商标权、专利权、商业秘密和其他所有相关权利）。未经汇才汇能许可，任何人不得擅自使用如上内容（包括但不限于通过程序或设备监视、复制、转播、展示、镜像、上传、下载汇才汇能网站内的任何内容）。被授权浏览、复制、打印和传播属于汇才汇能网站内信息内容的，该等内容都不得用于商业目的且所有信息内容及其任何部分的使用都必须包括此权利声明。
    </p>
    <br />
    <h6>二、责任限制</h6>
    <p>
      2.1.
      汇才汇能用户在汇才汇能网站的论坛、社区以及项目市场上，自行上传、提供、发布相关信息，包括但不限于用户名称、公司名称、联系人及联络信息，相关图片、资讯等，该等信息均由用户自行提供，用户所提供、填写、提交的所有材料、信息、文件等皆为真实、准确、合法的；汇才汇能的用户须对其提供的任何信息依法承担全部责任。
    </p>
    <p>
      2.2.汇才汇能网站上转载作品（包括论坛内容）出于传递更多信息之目的，并不意味汇才汇能赞同其观点或证实其内容的真实性。
    </p>
    <p>
      2.3.汇才汇能在此提示，您在使用汇才汇能网站服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用汇才汇能网站的服务从事他人侵犯名誉、隐私、知识产权和其他合法权益的活动。尽管有前述提示，汇才汇能不对您使用汇才汇能网站服务的用途和目的承担任何责任。
    </p>
    <br />
    <h6>三、知识产权保护</h6>
    <p>
      我们尊重知识产权，反对并打击侵犯知识产权的行为。任何组织或个人认为汇才汇能网站的网页（含www.huicaihuineng.com网页内容以及客户端页面）内容（如项目机会、新闻资讯等）可能侵犯其合法权益的，可以通过向汇才汇能提出书面权利通知，汇才汇能将在收到知识产权权利人合格通知后依法尽快处理。
    </p>
    <br />
    <br />
    <h5>隐私权政策</h5>
    <br />
    <p>
      汇才汇能（以下或称为“我们”）尊重并保护用户信息，并且将以高度勤勉和审慎的义务对待这些信息。在您使用了汇才汇能网站提供的服务时，我们将按照本隐私权政策收集、处理及披露您的信息。我们希望通过本隐私权政策向您清晰地介绍我们对您信息的处理方式，因此我们建议您完整地阅读本隐私权政策，以帮助您了解维护自己隐私权的方式。
    </p>
    <p>
      如果您有任何疑问、意见或建议，请通过汇才汇能提供的各种联系方式与我们联系。
    </p>
    <p>本政策将帮助您了解以下内容：</p>
    <p>一、本协议的适用范围</p>
    <p>二、我们如何收集和使用您的用户信息</p>
    <p>三、我们如何共享、转让、公开披露您的用户信息</p>
    <p>四、用户业务数据和公开信息</p>
    <p>五、您如何管理您的用户信息</p>
    <p>六、我们如何使用cookie和同类技术</p>
    <p>七、我们如何保护和保存您的用户信息</p>
    <p>八、未成年人用户信息的特别约定</p>
    <p>九、隐私权政策的更新</p>
    <p>十、如何联系我们</p>
    <br />
    <h5>一、本协议的适用范围</h5>
    <br />
    <p>
      1.1.本隐私权政策适用于汇才汇能网站所有服务。服务包括向您提供页面浏览、网站登录服务，以及通过汇才汇能网站向您提供的技术服务。
    </p>
    <p>
      1.2.本隐私权政策不适用于其他第三方向您提供的服务。例如，汇才汇能网站上的服务商向您提供服务时，您向服务商提供的信息不适用本隐私权政策。
    </p>
    <p>
      1.3.需要特别说明的是，作为汇才汇能的用户，若您利用汇才汇能的技术服务，为您的用户再行提供服务，因您的业务数据属于您所有，您应当另行与您的用户约定隐私权政策。
    </p>
    <br />
    <h5>二、我们如何收集和使用您的用户信息</h5>
    <br />
    <h6>（一）我们收集您的用户信息的情形</h6>
    <br />
    <p>2.1.帮助您成为我们的会员</p>
    <p>
      2.1.1.当您在汇才汇能网站创建账户时，您须向我们提供您在中华人民共和国境内手机号码和验证码，或通过微信扫码验证注册账户。您提交的手机号码或微信号用于您注册、登录、绑定账户，并且作为您与汇才汇能指定的联系方式之一，用来接受相关业务通知（如新品上线、服务变更等）。
    </p>
    <p>
      2.1.2.在您注册完成汇才汇能网站账户后，您可以在账户“基本资料”一栏中继续填写您的信息，包括（1）您的个人基本信息、工作经历、教育经历、专业能力、求职意向、项目经历；（2）联系信息（国家、所在地区、街道、联系电话、传真）。您若不提供这些信息，将不会影响您对某一具体技术服务的使用。您提供的本条第（1）类信息，会帮助我们更了解您对于汇才汇能网站服务需求，以便汇才汇能网站有针对性的向您推广、介绍产品；您提供的本条第（2）类信息，汇才汇能网站可能会利用如上方式向您推广、宣传产品、邮寄业务通知或与您进行业务沟通。
    </p>
    <p>
      2.1.3.在您注册完成汇才汇能网站账户后，您需在账号的管理控制台提交联系人信息，包括您指定联系人的邮箱、手机号码以及联系人的职位。汇才汇能网站将通过如上信息向您推广、介绍产品，发送业务通知（含账单）或与您进行业务沟通。
    </p>
    <p>
      2.1.4.如果您仅需使用汇才汇能网站的浏览等基本服务，您不需要注册成为我们的会员及提供上述信息。
    </p>
    <p>
      2.1.5.如果您已经注册有微信账号的，您可利用前述账号登录汇才汇能的网站。您通过微信账号登录汇才汇能网站的，您仍需按照汇才汇能网站提供的实名认证方式提交您的真实身份信息。我们会将依据与第三方的约定，在符合相关法律法规规定的前提下，使用您的这些用户信息。
    </p>
    <p>2.2.向您提供技术服务</p>
    <p>
      2.2.1.根据中华人民共和国法律，在您使用具体的技术服务时，应通过您的账号提供您的真实身份信息。用户通过汇才汇能网站账号提供真实身份信息的，汇才汇能网站为用户提供了多种方式以协助用户提供信息，用户应根据用户的身份属性选择适合的方式。如用户通过身份证实名认证来提供用户的真实信息，用户需输入真实姓名及对应身份证号，在完成实名认证后，用户即向汇才汇能网站提交了用户的姓名（单位主体名称）、身份证号码（营业执照号码）。
    </p>
    <p>
      2.2.2.在接受域名、备案等服务前，根据中华人民共和国相关法律法规的要求，汇才汇能将通过自有网站页面向您展示您需要提交的信息，以届时网站页面展示为准，如果您不使用某些服务，则无需提供相关信息。您在使用汇才汇能网站服务过程中，汇才汇能可能会收集以下的信息：
    </p>
    <p>
      2.2.2.1.设备信息：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（例如设备型号、操作系统版本、设备设置、唯一设备标识符等软硬件特征信息）、设备所在位置相关信息（例如IP地址、GPS位置以及能够提供相关信息的Wi-Fi接入点、蓝牙和基站等传感器信息）。我们可能会将前面两类信息进行关联，以便我们能在不同设备上为您提供一致的服务。
    </p>
    <p>
      2.2.2.2.日志信息：当您使用我们的网站或客户端提供的服务时，我们会自动收集您对我们服务的详细使用情况，作为有关网络日志保存。例如您的搜索查询内容、IP地址、浏览器的类型、电信运营商、使用的语言、访问日期和时间及您访问的网页记录等。
    </p>
    <p>
      2.2.2.3.用户账户的支持信息：基于您使用汇才汇能网站服务而产生的用户的咨询记录、报障记录和针对用户故障的排障过程（如通信或通话记录），汇才汇能网站将通过记录、分析这些信息以便更及时响应您的帮助请求，以及用于改进服务。
    </p>
    <p>
      2.2.3.我们在向您提供业务功能或具体服务时，我们会按照本政策以及相应的产品服务协议的约定收集、使用、存储、对外提供及保护您的用户信息；超出本政策以及相应的产品服务协议约定收集您的用户信息的，我们会另行向您说明信息收集的范围与目的，并征得您的同意后方收集提供相应服务所必要的您的信息；如您选择不提供前述信息，将会影响到您使用相应产品，但不会影响您使用汇才汇能网站基本功能和其他产品。
    </p>
    <br />
    <h6>（二）我们使用您的用户信息的情形</h6>
    <br />
    <p>2.3.我们出于如下目的，使用您提交以及我们收集的用户信息：</p>
    <p>
      2.3.1.为了向您提供服务，我们会向您发送信息、通知或与您进行业务沟通，包括但不限于为保证服务完成所必须的验证码、使用服务时所必要的推送通知；
    </p>
    <p>
      2.3.2.为了维护、改进服务，向您提供更符合您个性化需求的信息展示，我们可能将来自汇才汇能网站某项服务的用户信息与来自其他项服务的信息结合起来，做出特征模型并进行用户画像，向您展示、推送信息和可能的商业广告，包括但不限于关于汇才汇能网站项目的更新、新闻资讯，或其他您可能感兴趣的内容。如果您不想接收我们给您发送的商业性电子信息，您可通过短信提示回复退订或根据信息中提供的退订方式予以退订；
    </p>
    <p>
      2.3.3.我们可能以用户信息统计数据为基础，设计、开发、推广全新的产品及服务；我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息不包含您的任何身份识别信息；
    </p>
    <p>
      2.3.4.为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或汇才汇能网站相关协议、规则的情况，我们可能使用您的会员信息、并整合设备信息、有关网络日志以及我们关联公司、合作伙伴合法分享的信息，来判断您账户及交易风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施；
    </p>
    <p>
      2.3.5.如超出收集用户信息时所声称的目的，或者在超出具有直接或合理关联的范围使用用户信息前，我们会再次向您告知并征得您的明确同意。
    </p>
    <br />
    <h6>三、我们如何共享、转让、公开披露您的用户信息</h6>
    <br />
    <h6>3.1.共享</h6>
    <br />
    <p>我们不会与其他组织和个人共享您的用户信息，但以下情况除外：</p>
    <p>
      3.1.1.在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的用户信息；
    </p>
    <p>
      3.1.2.在法定情形下的共享：我们可能会根据法律法规规定、诉讼、仲裁解决需要，或按行政、司法机关依法提出的要求，对外共享您的用户信息；
    </p>
    <p>
      3.1.3.为了促成交易或协助解决争议，某些情况下只有共享您的用户信息，才能促成交易或处理您与他人的纠纷或争议，例如，在汇才汇能网站上创建的某一项目中，如交易任何一方履行或部分履行了交易义务并提出信息披露请求的，汇才汇能有权决定向该用户提供其交易对方的联络方式等必要信息，以促成交易的完成；
    </p>
    <br />
    <h6>3.2.转让</h6>
    <br />
    <p>我们不会将您的用户信息转让给任何公司、组织和个人，但以下情况除外：</p>
    <p>
      3.2.1.在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的用户信息；
    </p>
    <p>
      3.2.2.在汇才汇能与其他法律主体者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到用户信息转让，我们会要求新的持有您用户信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。
    </p>
    <br />
    <h6>3.3.公开披露</h6>
    <br />
    <p>我们仅会在以下情况下，公开披露您的用户信息：</p>
    <p>
      3.3.1．获得您明确同意或基于您的主动选择，我们可能会公开披露您的用户信息；
    </p>
    <p>
      3.3.2.或为保护汇才汇能及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据适用的法律或汇才汇能网站相关协议、规则披露关于您的用户信息。例如，若您作为项目服务商提供非法服务或盗版商品，我们可能会公开披露您的主体信息与处罚情况。
    </p>
    <br />
    <h6>3.4.共享、转让、公开披露用户信息时事先征得授权同意的例外</h6>
    <br />
    <p>
      以下情形中，共享、转让、公开披露您的用户信息无需事先征得您的授权同意：
    </p>
    <p>3.4.1.与国家安全、国防安全有关的；</p>
    <p>3.4.2.与公共安全、公共卫生、重大公共利益有关的；</p>
    <p>3.4.3.与犯罪侦查、起诉、审判和判决执行等有关的；</p>
    <p>
      3.4.4.出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
    </p>
    <p>3.4.5.您自行向社会公众公开的个人信息；</p>
    <p>
      3.4.6.从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
    </p>
    <br />
    <h5>四、用户业务数据和公开信息</h5>
    <br />
    <p>
      不同于您的用户信息，对于用户业务数据和公开信息，汇才汇能网站将按如下方式处理：
    </p>
    <br />
    <h6>4.1.用户业务数据</h6>
    <br />
    <p>
      4.1.1.您通过汇才汇能网站提供的服务，加工、存储、上传、下载、分发以及通过其他方式处理的数据，均为您的用户业务数据，您完全拥有您的用户业务数据。汇才汇能平台只会严格执行您的指示处理您的业务数据，除按与您协商一致或执行明确的法律法规要求外，不对您的业务数据进行任何非授权的使用或披露。
    </p>
    <p>
      4.1.2.您应对您的用户业务数据来源及内容负责，汇才汇能提示您谨慎判断数据来源及内容的合法性。因您的用户业务数据内容违反法律法规、部门规章或国家政策而造成的全部结果及责任均由您自行承担。
    </p>
    <p>
      4.1.3.根据您与汇才汇能协商一致，汇才汇能在您选定的数据中心存储用户业务数据。汇才汇能恪守对用户的安全承诺，根据适用的法律保护用户存储在汇才汇能数据中心的数据。
    </p>
    <br />
    <h6>4.2.公开信息</h6>
    <br />
    <p>
      4.2.1.公开信息是指您公开分享的任何信息，任何人都可以在使用和未使用汇才汇能网站服务期间查看或访问这些信息。例如您在汇才汇能网站论坛发布的信息。
    </p>
    <p>
      4.2.2对于进入公开领域的用户业务数据，在汇才汇能收集与处理这些信息时，将作为一般公开信息对待，不再按用户业务数据的处理方式对待。
    </p>
    <p>
      4.2.3.在使用汇才汇能网站开展项目时，您不可避免的要向交易对方或潜在的交易对方披露自己的个人信息，如联络方式或者邮政地址。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。您也可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的联络方式、交流信息或分享内容等相关信息的第三方。如您发现自己的个人信息泄漏，尤其是您的账户或密码发生泄露，请您立即联络汇才汇能网站客服，以便汇才汇能网站采取相应措施。
    </p>
    <br />
    <h5>五、您如何管理您的用户信息</h5>
    <br />
    <p>
      5.1.您可以登录汇才汇能网站或小程序“人才信息”查询、管理（变更、删除）使用汇才汇能网站服务时而提交的资料和联系人信息。
    </p>
    <p>
      5.2.如果您需要变更您汇才汇能网站账户下的实名认证信息，您需通过工单、电话等方式联系汇才汇能，按照汇才汇能网站的操作文档或在工作人员的指导下进行操作。
    </p>
    <p>5.3.在以下情形中，您可以向我们提出删除用户信息的请求：</p>
    <p>5.3.1.确定不再继续使用汇才汇能相关的业务及服务</p>
    <p>5.3.2.如果我们处理用户信息的行为违反法律法规；</p>
    <p>5.3.3.如果我们收集、使用您的用户信息，却未征得您的明确同意；</p>
    <p>5.3.4.如果我们处理个人信息的行为严重违反了与您的约定。</p>
    <p>
      为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
    </p>
    <p>
      5.4每个业务功能需要一些基本的用户信息才能得以完成（见本隐私权政策第二条）。除此之外，您可以在与汇才汇能网站客服联系给予或收回您的授权同意。当您收回同意后，我们将不再处理相应的用户信息。但您收回同意的决定，不会影响此前基于您的授权而开展的用户信息处理。
    </p>
    <p>
      5.5在删除用户信息后，汇才汇能将停止对您用户信息的继续使用（法律法规要求汇才汇能必须履行的义务除外）。
    </p>
    <br />
    <h5>六、我们如何使用Cookie和同类技术</h5>
    <br />
    <p>
      6.1.为确保网站正常运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的计算机或移动设备上存储名为Cookie的小数据文件。Cookie通常包含标识符、站点名称以及一些号码和字符。汇才汇能网站只能读取汇才汇能网站提供的cookies。
    </p>
    <p>
      6.2.借助于Cookie，能够存储您的偏好或购买清单中的商品等数据。当下一次您再次访问的时候，我们将显示您需要的信息；或由汇才汇能网站通过cookies文件来辨识您的来源网站，以便汇才汇能网站能追踪汇才汇能的广告效果。
    </p>
    <p>
      6.3.您可根据自己的偏好管理Cookie，您也可以清除计算机上保存的所有Cookie。大部分网络浏览器都设有阻止Cookie的功能。但如果您这么做，则需要在每一次访问我们的网站时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。
    </p>
    <p>
      6.4.除Cookie外，我们还会在网站上使用网站信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至我们网站内容的地址链接，如果您点击该链接，我们则会跟踪此次点击，帮助我们了解您的产品或服务偏好以便于我们主动改善客户服务体验。网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。如果您不希望自己的活动以这种方式被追踪，则可以随时从我们的寄信名单中退订。
    </p>
    <br />
    <h5>七、我们如何保护和保存您的用户信息</h5>
    <br />
    <p>
      7.1.汇才汇能非常重视您的信息安全。我们努力采取各种合理的物理、电子和管理方面的安全措施来保护您的用户信息。防止用户信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会使用加密技术提高用户信息的安全性；我们会使用受信赖的保护机制防止用户信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问用户信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护用户信息重要性的认识。
    </p>
    <p>
      7.2.我们会采取合理可行的措施，尽力避免收集无关的用户信息。我们只会在达成本政策所述目的所需的期限内保留您的用户信息，除非受到法律的允许。超出上述用户信息保存期限后，我们会对您的个人信息进行删除或匿名化处理。
    </p>
    <p>
      7.3.请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。
    </p>
    <p>
      7.4.在不幸发生用户信息安全事件（泄露、丢失等）后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知用户信息主体时，我们会采取合理、有效的方式发布公告。
    </p>
    <p>7.5.同时，我们还将按照监管部门要求，上报用户信息安全事件的处置情况。</p>
    <p>
      7.6.我们将收集到的您的用户信息存放在中华人民共和国境内，如在符合适用法律规定的情形下因业务需要向境外传输个人信息的，我们会事先征得您的同意，并向您告知用户信息出境的目的、接收方、安全保障措施、安全风险等情况。
    </p>
    <p>
      7.7.如出现汇才汇能网站和服务停止运营的情形，我们会采取合理措施保护您用户信息安全，包括及时停止继续收集用户信息的活动；停止运营的通知将以逐一送达或公告的形式通知用户；并对所持有的个人信息进行删除或匿名化处理等。
    </p>
    <br />
    <h5>八、未成年人用户信息的特别约定</h5>
    <br />
    <p>
      8.1.汇才汇能网站服务不提供给任何 16
      岁以下的人。为使用汇才汇能网站，您同意：(1)您必须满足“最低年龄”要求(见下文)；(2)您只能拥有一个汇才汇能网站账号，并且使用实名；以及(3)汇才汇能网站尚未限制您使用。使用虚假信息创建账号的行为违反了我们的条款，包括代表他人注册账号或代表未满16岁的人注册账号等行为。“最低年龄”系指16岁。但是，如果法律规定您必须达到某个更大的年龄，汇才汇能网站才能在未经父母同意的情况下合法为您提供服务(包括使用您的个人信息)，则“最低年龄”为该规定年龄。
    </p>
    <p>
      8.2.对于经父母或监护人同意使用我们的产品或服务而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。
    </p>
    <br />
    <h5>九、隐私权政策的更新</h5>
    <br />
    <p>
      9.1.汇才汇能的隐私权政策将随着法律法规变化以及公司经营需要而不时做出修订。
    </p>
    <p>
      9.2.未经您明确同意，我们不会限制您按照本隐私权政策所应享有的权利。我们会在专门页面上发布对隐私权政策所做的任何修订。
    </p>
    <p>
      9.3.对于重大修订，我们还会提供更为显著的通知（包括对于某些服务，我们会通过网站公示的方式进行通知甚至向您提供弹窗提示，说明隐私权政策的具体变更内容）。
    </p>
    <p>9.4.本政策所指的重大变更包括但不限于：</p>
    <p>
      9.4.1.我们的服务模式发生重大变化。如处理用户信息的目的、处理的用户信息类型、用户信息的使用方式等；
    </p>
    <p>
      9.4.2.我们在控制权、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
    </p>
    <p>9.4.3.用户信息共享、转让或公开披露的主要对象发生变化；</p>
    <p>9.4.4.您参与用户信息处理方面的权利及其行使方式发生重大变化；</p>
    <p>
      9.4.5.我们负责处理用户信息安全的责任部门、联络方式及投诉渠道发生变化时；
    </p>
    <p>9.4.6.用户信息安全影响评估报告表明存在高风险时。</p>
    <br />
    <h5>十、如何联系我们</h5>
    <br />
    <p>
      您对本声明和政策内容有任何疑问和意见，或者您对汇才汇能对本隐私权政策的实践以及操作上有任何疑问和意见，您可通过汇才汇能网站的工单或客服邮箱hchn_hr@163.com与我们联系。
    </p>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
.privacy-container {
  margin: 5% 10% 10%;
  text-align: left;
}
</style>
